var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExistingSystems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-laptop",
    "data-name": "Icon awesome-laptop",
    d: "M43.875,29.25H26.827a2.217,2.217,0,0,1-2.3,2.25H20.25a2.388,2.388,0,0,1-2.3-2.25H1.125A1.128,1.128,0,0,0,0,30.375V31.5A4.513,4.513,0,0,0,4.5,36h36A4.513,4.513,0,0,0,45,31.5V30.375A1.128,1.128,0,0,0,43.875,29.25ZM40.5,3.375A3.385,3.385,0,0,0,37.125,0H7.875A3.385,3.385,0,0,0,4.5,3.375V27h36ZM36,22.5H9V4.5H36Z",
    fill: "#3db6fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingSystems);
export default __webpack_public_path__ + "static/media/Existing Systems.814ff93de56f3be4be12dfb266ad41d8.svg";
export { ForwardRef as ReactComponent };